import { Admin, Resource } from 'react-admin';
import { BoardingCenterCreate } from '../boardingCenters/BoardingCenterCreate';
import { BoardingCenterEdit } from '../boardingCenters/BoardingCenterEdit';
import { BoardingCenterList } from '../boardingCenters/BoardingCenterList';
import { BreederCreate } from '../breeders/BreederCreate';
import { BreederEdit } from '../breeders/BreederEdit';
import { BreederList } from '../breeders/BreederList';
import MyLayout from '../components/AppBar/MyLayout';
import MyLoginPage from '../pages/MyLoginPage';
import { OrderCreate } from '../orders/OrderCreate';
import { OrderEdit } from '../orders/OrderEdit';
import { OrderList } from '../orders/OrderList';
import axios from 'axios';
import ZipcodePage from '../zipcode/ZipcodePage';
import authProvider from '../authProvider/authProvider';
import { CustomDataProvider } from '../provider/CustumDataProvider';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StorefrontIcon from '@mui/icons-material/Storefront';
import HouseIcon from '@mui/icons-material/House';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ApartmentIcon from '@mui/icons-material/Apartment';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import PaidIcon from '@mui/icons-material/Paid';
import GrassIcon from '@mui/icons-material/Grass';
import PaletteIcon from '@mui/icons-material/Palette';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import ListIcon from '@mui/icons-material/List';
import FileReader from '../inventory/FileReader';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import UserIcon from '@mui/icons-material/Person';
import DryCleaningIcon from '@mui/icons-material/DryCleaning';
import { UserCreate } from '../users/UserCreate';
import { UserEdit } from '../users/UserEdit';
import { UserList } from '../users/UserList';
import { useEffect, useState } from 'react';
import { roles, isWarehouseManagerRole } from '../users/roles';
import HubIcon from '@mui/icons-material/Hub';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import FilterFramesIcon from '@mui/icons-material/FilterFrames';
import PetsIcon from '@mui/icons-material/Pets';
import GrommerCreate from '../groomers/GrommerCreate';
import GrommerList from '../groomers/GrommerList';
import GrommerEdit from '../groomers/GroomerEdit';
import RecreationCenterCreate from '../recreationCenters/RecreationCenterCreate';
import RecreationCenterEdit from '../recreationCenters/RecreationCenterEdit';
import RecreationCenterList from '../recreationCenters/RecreationCenterList';
import TrainerCreate from '../trainers/TrainerCreate';
import TrainerEdit from '../trainers/TrainerEdit';
import TrainerList from '../trainers/TrainerList';
import VetCreate from '../vets/VetCreate';
import VetEdit from '../vets/VetEdit';
import VetList from '../vets/VetList';
import { Box, CircularProgress } from '@mui/material';
import { defaultTheme } from 'react-admin';
import indigo from '@mui/material/colors/indigo';
import yellow from '@mui/material/colors/yellow';
import red from '@mui/material/colors/red';

const myTheme = {
    ...defaultTheme,
    palette: {
        primary: indigo,
        secondary: yellow,
        error: red,
        contrastThreshold: 3,
        tonalOffset: 0.2,
    },
    typography: {
        fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Arial', 'sans-serif'].join(','),
    },
};

const Ready = () => (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
        >
            <CircularProgress />
        </Box>
)

export const StoreAdmin = () => {
    const [roleData, setRoleData] = useState([]);
    const { roles, id, accessToken } = JSON.parse(localStorage.getItem("auth")) || { roles: [], id: null, accessToken: null };
    
    const rolesAPI = async() => {
        try {
            if (!id || !accessToken) {
                console.log("Missing user ID or access token");
                return;
            }
            
            const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/api/users/${id}`,
            {
                headers: {
                    authorization: `Bearer ${accessToken}`
                }
            });
            setRoleData(response?.data);

        }
        catch (error) {
            console.log("Error fetching user data:", error);
            if (error.response && (error.response.status === 404 || error.response.status === 500)) {
                console.log("Using fallback roles from localStorage:", roles);
                setRoleData({ roles: Array.isArray(roles) ? roles : [roles].filter(Boolean) });
            }
        }
    };

    useEffect(() => {
        if(accessToken){
            rolesAPI();
        }
    }, [accessToken]);

    const role = roleData?.roles || roles || [];
    
    const hasWarehouseManagerRole = Array.isArray(role) 
        ? role.some(r => isWarehouseManagerRole(r))
        : isWarehouseManagerRole(role);
       
    return ( 
        <Admin ready={Ready} basename="/admin" layout={MyLayout} loginPage={MyLoginPage} theme={myTheme} dataProvider={CustomDataProvider} authProvider={authProvider}>
            <>
                { role.includes('admin') ? <Resource name="api/zipcodes" options={{label: "Zipcode Mapping"}} list={ZipcodePage} icon={LocalShippingIcon} /> : null }
                
                { role.includes('admin') || hasWarehouseManagerRole
                  ? <Resource name="api/orders" options={{label:"Orders"}} list={OrderList} edit={OrderEdit} create={OrderCreate} icon={PaidIcon}/> 
                  : null }
                
                { role.includes('admin') ? <Resource name="api/users" options={{label:"Users"}} list={UserList} icon={UserIcon} edit={UserEdit} create={UserCreate} /> : null }
                
                { role.includes('admin') ? <Resource name="files/inventory-uploads" options={{label:"Inventory Uploads"}} list={<FileReader />} icon={AddBusinessIcon} /> : null }
                { role.includes("inventory_manager") ? <Resource name="files/inventory-uploads" options={{label:"Inventory Uploads"}} list={<FileReader />} icon={AddBusinessIcon} /> : null }
            </>
        </Admin>
    );
}
